import { BTh } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBTh = createEgBootstrapProxy("EgBTh", BTh);
